<template>
	<div class="Box">
		<!-- <div class="Menu">
			<ul>
				<li class="menuText" @click="Menuscroll(1)">文化活动</li>
				<li class="menuText" @click="Menuscroll(1)">招聘信息</li>
			</ul>
		</div> -->
		<!-- 文化活动 -->
		<div class="title wenHeight">
			<div class="bgimg">
				<img src="../assets/img/jj01.png" alt="">
			</div>
			<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
				<p class="name">文化活动</p>
				<p class="english">CULTURAL EVENTS</p>
			</div>
		</div>
		<div class="environment">
			<div class="trans">
				<swiper ref="mySwiper" :options="swiperOptions" class="banner">
					<swiper-slide v-for="item in culture">
						<div class="trans_li">
							<div class="trans_img">
								<img :src="item.pic" alt="">
							</div>
							<div class="trans_name">{{item.title}}</div>
						</div>
					</swiper-slide>
				</swiper>
				<div class="btn left"><img src="../assets/img/left.png"></div>
				<div class="btn right"><img src="../assets/img/right.png"></div>
			</div>

		</div>
		<!-- 招聘信息 -->
		<div class="title joinheight">
			<div class="bgimg">
				<img src="../assets/img/jj02.png" alt="">
			</div>
			<div class="text" @mouseenter="titleEnter($event)" @mouseleave="titleLeave($event)">
				<p class="name">招聘信息</p>
				<p class="english">JOIN US</p>
			</div>
		</div>
		<div class="join">
			<!-- 招聘大图 -->
			<div class="joinImg">
				<img src="../assets/img/invatejoin.png" alt="">
			</div>
			<!-- 添加的文字 -->
			<div class="joinText">
				<p>应聘简历请发送至hr@amazingray.cn</p>
			</div>
			<!-- 部门 -->
			<div class="departmentBox">
				<!-- 循环的整个大的部门 -->
				<div class="department" v-for="item in invite" :key="item.title">
					<div class="department_title">
						<div class="title_left"></div>
						<p>{{item.title}}</p>
					</div>
					<!-- 循环的岗位 -->
					<div class="department_post" v-for="element in item.inviteList" :key="item.inviteList.index">
						<div class="post_left">
						</div>
						<!-- <div class="post_left">
							<img src="../assets/img/sanjiao.png" alt="">
						</div> -->
						<p class="post_name" data-open="open" @click="department($event)">{{element.title}}</p>
						<div class="post_content" v-html="element.textBody">
							{{element.textBody}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'
	export default {
		name: 'join',
		components: {
			Swiper,
			SwiperSlide
		},
		directives: {
			swiper: directive
		},
		data() {
			return {
				swiperOptions: {
					pagination: {
						el: '.swiper-pagination',
					},
					navigation: {
						nextEl: '.right',
						prevEl: '.left',
					},
					slidesPerView: 4, //页面可视数（网格）
				},
				culture: [], //文化
				invite: [],
				jHeight: '',
				queryNum: "", //监听当前路由是否发生变化
				wenHeight: ""
			}
		},
		watch: {
			$route: {
				handler() {
					this.queryNum = this.$route.query.num;
					// this.getDetail();
					//深度监听，同时也可监听到param参数变化
				},
				deep: true,
			},
			queryNum(newValue, old) {
				if (newValue != old) {
					console.log("页面的值由" + old + "变为" + newValue)
					if (newValue == 51) {
						this.scroll1()
					} else if (newValue == 52) {
						this.scroll2()
					}
				}
			}
		},
		methods: {
			//鼠标移入标题
			titleEnter(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1.1,1.1)'
				bgimg.style.transitionDuration="1s"
			},
			//鼠标移出标题
			titleLeave(e){
				let bgimg = e.target.previousElementSibling 
				bgimg.style.transform = 'scale(1,1)'
				bgimg.style.transitionDuration="1s"
			},
			//获取新闻动态
			getNews() {
				this.$api.get(this.$httpApi + this.$path.INDEX_NEWS).then(res => {
					// console.log("新闻动态", res.data);
					this.news = res.data.data[0];
					this.scroll1();
				}).catch(err => {})
			},
			//招聘信息展开效果
			department(e) {
				console.log('当前元素', e.target)
				e.stopPropagation() //阻止冒泡事件流
				//if折叠
				if (e.target.dataset.open == "false") {
					// 展开高度
					let department_post = e.target.parentElement
					// department_post.style.height = 'auto'
					department_post.style.maxHeight = '3rem'
					department_post.style.transition="max-height 0.5s"
					// 展开三角形
					let post_left = e.target.parentElement.firstChild
					post_left.style.transform = 'rotate(0deg)' /* 默认展开:true,上三角形,0deg,默认合上:false,左三角形,90deg */
					//更改后自定义属性为true
					let post_name = e.target
					post_name.setAttribute('data-open', 'true')
					console.log('我要展开')
				} else {
				//else展开	
					// post_name.setAttribute('data-open', 'true') //更改后自定义属性
					
					console.log("此时已经展开了,点击合上")
					
					//收起高度
					// e.target.parentElement.style.height = '0.25rem'
					e.target.parentElement.style.maxHeight = '0.25rem'
					e.target.parentElement.style.transition="max-height 0.5s"
					//三角形合上
					e.target.parentElement.firstChild.style.transform = 'rotate(-90deg)'/* 默认展开:,默认合上:rotate(0deg) */
					//更改后自定义属性为false
					e.target.setAttribute('data-open', 'false')
				}
			},
			//获取文化活动
			getCulture() {
				this.$api.get(this.$httpApi + this.$path.INDEX_CULTURE).then(res => {
					// console.log("文化信息", res.data);
					this.culture = res.data.data;
					this.scroll1();
				}).catch(err => {})
			},
			//获取招聘信息
			getInvite() {
				this.$api.get(this.$httpApi + this.$path.INDEX_INVITE).then(res => {
					// console.log("招聘信息", res.data);
					this.invite = res.data.data
					this.scroll2()
				}).catch(err => {})
			},
			//滚动到文化活动的高度
			scroll1() {
				this.$nextTick(() => {
					//获取高度
					let wenHeight = document.querySelector('.wenHeight')
					this.wenHeight = wenHeight.offsetTop
					//设置高度
					if (this.$route.query.num == 51) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.wenHeight
							document.documentElement.scrollTop = _this.wenHeight
						}, 5);
					}
				})
			},
			//滚动到招聘信息的高度
			scroll2() {
				this.$nextTick(() => {
					//获取高度
					let joinheight = document.querySelector('.joinheight')
					this.jHeight = joinheight.offsetTop
					//设置高度
					if (this.$route.query.num == 3 || this.$route.query.num == 52) {
						let _this = this;
						setTimeout(function() {
							document.body.scrollTop = _this.jHeight
							document.documentElement.scrollTop = _this.jHeight
						}, 5);
					}
				})
			},
			//横板菜单滚动到页面指定位置
			Menuscroll(value) {
				if (value == 1) {
					let wenHeight = document.querySelector('.wenHeight')
					this.wenHeight = wenHeight.offsetTop
					//设置高度
					document.body.scrollTop = this.wenHeight
					document.documentElement.scrollTop = this.wenHeight
				}else if(value==2){
					let joinheight = document.querySelector('.joinheight')
					this.jHeight = joinheight.offsetTop
					//设置高度
					document.body.scrollTop = this.jHeight
					document.documentElement.scrollTop = this.jHeight
				}
			}
		},
		mounted() {
			this.getCulture()
			this.getInvite()
			this.$router.afterEach((to, from, next) => {
				window.scrollTo(0, 0)
			})
		}

	}
</script>

<style scoped>
	.Box {
		width: 19.20rem;
	}

	/* 菜单 */
	.Menu {
		width: 100%;
		height: 0.4rem;
		background-color: #05060a;
		line-height: 0.20rem;
		padding-left: 5.10rem;
		box-sizing: border-box;
	}

	.menuText {
		color: #ffffff;
		font-size: 0.18rem;
		float: left;
		margin-right: 1rem;
		cursor: pointer;
	}

	/* 标题开始 */
	.title {
		width: 100%;
		height: 2.40rem;
		padding: 0 1.4rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		position: relative;
		border-bottom: 0.01rem solid #666666;
	}

	.bgimg {
		width: 1.86rem;
		height: 1.72rem;
		position: absolute;
		left: 1.32rem;
		top: 0.35rem;
	}

	.bgimg img {
		/* width: 100%; */
		height: 100%;
	}

	.text {
		min-width: 4.80rem;
		height: 2.00rem;
		position: absolute;
		left: 1.32rem;
		top: 0.20rem;
		z-index: 2;
	}
	.text:hover{
		cursor: pointer;
	}

	.name {
		color: #FFFFFF;
		font-size: 0.32rem;
		text-align: left;
		margin-top: 0.60rem;
		line-height: 0.50rem;
		font-weight: 500;
		letter-spacing: 0.03rem;
	}

	.english {
		color: #FFFFFF;
		font-size: 0.21rem;
		line-height: 0.30rem;
		font-weight: 500;
		text-align: left;
	}

	.det {
		color: #d5d5d5;
		font-size: 0.14rem;
		line-height: 0.20rem;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	/* 标题结束 */

	.environment {
		width: 100%;
		height: 6.40rem;
		padding: 1.20rem 1.36rem;
		box-sizing: border-box;
		background-color: #0F0F0F;
		border-bottom: 0.01rem solid #666666;
	}

	.trans {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.banner {
		width: 15.30rem;
		height: 4.00rem;
	}

	.btn {
		width: 0.30rem;
		height: 0.56rem;
		outline: none;
		position: absolute;
		cursor: pointer;
	}

	.left {
		position: absolute;
		left: 0;
		top: 1.28rem;
	}

	.right {
		position: absolute;
		right: 0;
		top: 1.28rem;
	}

	.left>img,
	.right>img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.trans_li {
		width: 3.70rem;
		height: 100%;
		/* float: left; */
		margin-right: 0.24rem;
	}

	.trans_li:last-child {
		margin: 0;
	}

	.trans_img {
		width: 100%;
		height: 3.25rem;
	}

	.trans_img img {
		width: 100%;
		height: 100%;
	}

	.trans_name {
		width: 100%;
		height: 0.24rem;
		margin-top: 0.50rem;
		text-align: center;
		color: #FFFFFF;
		font-size: 0.24rem;
		font-weight: 600;
		line-height: 0.24rem;
	}

	/* 招聘信息 */
	.join {
		width: 100%;
		height: auto;
		padding: 0.64rem 1.34rem;
		background-color: #0F0F0F;
		box-sizing: border-box;
	}

	.joinImg {
		width: 16.42rem;
		height: 4.43rem;
		margin: 0 auto;
	}

	.joinImg img {
		width: 100%;
		height: 100%;
	}
	.joinText{
		width: 100%;
		height: 0.2rem;
		margin-top: 0.4rem;
		font-size: 0.16rem;
		color: #e3e3e3;
		text-align: left;
		line-height: 0.2rem;
	}

	/* 部门介绍 */
	.departmentBox {
		width: 100%;
		height: auto;
		margin: 0.30rem 0;
	}

	.department {
		width: 100%;
	}

	.department_title {
		width: 100%;
		height: 0.42rem;
		margin-bottom: 0.40rem;
	}

	.title_left {
		width: 0.08rem;
		height: 0.42rem;
		float: left;
		background-color: #f80000;
	}

	.department_title p {
		font-size: 0.32rem;
		line-height: 0.42rem;
		text-align: left;
		margin-left: 0.40rem;
		color: #FFFFFF;
	}

	.department_post {
		width: 100%;
		overflow: hidden;
		/* height: 0.25rem; */
		/* height: auto; */
		max-height:4rem;
		
		/* 默认0.25rem,当展开后高度变为auto */
		/* 如果默认全部展开,那么默认为auto,合上后是0.25rem */
		color: #FFFFFF;
		font-size: 0.22rem;
		line-height: 0.25rem;
		text-align: left;
		margin-bottom: 0.40rem;
	}

	.post_name {
		margin-left: 0.40rem;
		cursor: pointer;
	}
     /* 三角形 */
	.post_left {
		width: 0.13rem;
		height: 0.26rem;
		float: left;
		width: 0;
		height: 0;
		border-top: 0.13rem solid #ff0000;
		border-left: 0.13rem solid transparent;
		border-right: 0.13rem solid transparent;
		border-bottom: 0.13rem solid transparent;
		float: left;
		transition-duration: 0.5s;
	}
	/* .post_left>img{
		width: 0.13rem;
		height: 0.26rem;
	} */

	.post_content {
		width: 100%;
		height: auto;
		padding-left: 0.40rem;
		padding-top: 0.20rem;
		padding-bottom: 0.20rem;
		boxb-sizing: border-box;
		color: #e5e5e5;
		font-size: 0.16rem;
		line-height: 0.30rem;
		text-align: justify;
		box-sizing: border-box;
		
	}

	.post_contact {
		margin-left: 0.40rem;
		color: #FFFFFF;
		font-size: 0.16rem;
	}
</style>



// WEBPACK FOOTER //
// src/pages/join.vue